import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-top: 24px;
  padding: 12px;
  border: 1px solid #444;
  color: #e1d6c0;
  font-family: sans-serif;
`;

const Title = styled.h3`
  margin-bottom: 16px;
  color: #e1d6c0;
`;

const ItemRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;

  input, select {
    flex: 1;
    padding: 6px 8px;
    border: 1px solid #666;
    border-radius: 4px;
    background: #111;
    color: #fff;
  }

  button {
    padding: 6px 12px;
    border: 1px solid #e1d6c0;
    border-radius: 4px;
    background: transparent;
    color: #e1d6c0;
    cursor: pointer;
    &:hover { opacity: 0.8; }
  }
`;

const AddButton = styled.button`
  margin-top: 12px;
  padding: 6px 12px;
  border: 1px solid #e1d6c0;
  border-radius: 4px;
  background: transparent;
  color: #e1d6c0;
  cursor: pointer;
  &:hover { opacity: 0.8; }
`;

const Subheading = styled.h4`
  margin: 16px 0 8px;
  color: #e1d6c0;
  font-size: 1.1rem;
`;

const CategoryRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 6px 8px;
  background: #111;
  border: 1px solid #666;
  border-radius: 4px;
  margin-bottom: 4px;
  color: #fff;

  button {
    border: none;
    background: transparent;
    color: #e1d6c0;
    cursor: pointer;
    &:hover { opacity: 0.8; }
  }
`;

export default function PageEditor({ page, token, onChange }) {
    const isNew = !page;
    const [title, setTitle]   = useState(page?.title    || '');
    const [position, setPos]  = useState(page?.position || '');
    const [cats, setCats]     = useState([]);
    const [allCats, setAllCats] = useState([]);
  
    useEffect(() => {
      if (!page) return;
      // assigned categories
      fetch(`/api/admin/pages/${page.id}/categories`, {
        headers:{ Authorization: 'Bearer '+token }
      })
        .then(r=>r.json())
        .then(setCats);
  
      // all categories for dropdown
      fetch('/api/admin/categories', {
        headers:{ Authorization: 'Bearer '+token }
      })
        .then(r=>r.json())
        .then(setAllCats);
    }, [page, token]);
  
    const savePage = async () => {
      const url    = page
        ? `/api/admin/pages/${page.id}`
        : `/api/admin/pages`;
      const method = page ? 'PUT' : 'POST';
      await fetch(url, {
        method, 
        headers:{
          'Content-Type':'application/json',
          Authorization:'Bearer '+token
        },
        body: JSON.stringify({ title, position: +position })
      });
      onChange();
      alert('Page is saved');
    };

    const handleDeletePage = async () => {
          if (!window.confirm('Delete this page forever?')) return;
          await fetch(`/api/admin/pages/${page.id}`, {
            method: 'DELETE',
            headers: { Authorization: 'Bearer '+token }
          });
          onChange();
        };
  
    const addCatToPage = async e => {
      const catId = +e.target.value;
      await fetch(`/api/admin/pages/${page.id}/categories`, {
        method: 'POST',
        headers:{
          'Content-Type':'application/json',
          Authorization:'Bearer '+token
        },
        body: JSON.stringify({
          category_id: catId,
          position: cats.length + 1
        })
      });
      onChange();
    };
  
    const removeCat = async catId => {
      await fetch(
        `/api/admin/pages/${page.id}/categories/${catId}`,
        { method:'DELETE', headers:{ Authorization:'Bearer '+token } }
      );
      onChange();
    };
  
    return (
      <Wrapper>
        <Title>{isNew ? 'New Menu Page' : `Edit: ${page.title}`}</Title>
  
        {/* Page title & position */}
        <ItemRow>
          <input
            placeholder="Page Title"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
          <input
            type="number"
            placeholder="Position"
            value={position}
            onChange={e => setPos(e.target.value)}
            style={{ maxWidth: 80 }}
          />
          <button onClick={savePage} disabled={!title || !position}>
            {isNew ? 'Create Page' : 'Save Page'}
          </button>
          {/* only show Delete on existing pages */}
          {!isNew && (
            <button onClick={handleDeletePage}>
            Delete Page
            </button>
          )}
        </ItemRow>
  
        {!isNew && (
          <>
            <Subheading>Assigned Categories</Subheading>
            {cats.map(c => (
              <CategoryRow key={c.id}>
                {c.name}
                <button onClick={() => removeCat(c.id)}>✕</button>
              </CategoryRow>
            ))}
  
            <Subheading>Add Category to Page</Subheading>
            <ItemRow>
              <select defaultValue="" onChange={addCatToPage}>
                <option value="" disabled>Select category…</option>
                {allCats
                  .filter(c => !cats.find(x => x.id === c.id))
                  .map(c => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))
                }
              </select>
            </ItemRow>
          </>
        )}
      </Wrapper>
    );
  }
